import { useRef } from "react";
export default function useDedupe(value, equal) {
    const ref = useRef(value);
    if (!equal(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
